import { useCopyToClipboard } from '@modules/common/hooks';
import { useGetRequestDashboardAccessLink } from '@modules/dashboard/hooks';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  Box,
  Grid,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { DashboardViewFragment } from 'generated/graphql';

interface RequestSentContentProps {
  onClose: () => void;
  dashboard: Pick<DashboardViewFragment, 'createdBy' | 'title'>;
}

export const RequestSentContent = ({
  onClose,
  dashboard,
}: RequestSentContentProps) => {
  const dashboardRequestAccessLink = useGetRequestDashboardAccessLink({
    dashboardLink: window.location.toString(),
  });
  const copyTextToClipboard = useCopyToClipboard();
  const copyMessage = () => {
    const message = `Hi ${dashboard.createdBy.firstName} 👋 \nCan you please grant me access to the “${dashboard.title}” Dashboard on Enterpret?\nYou can use the following link to approve it in 1 click.\n${dashboardRequestAccessLink}`;

    copyTextToClipboard(message);
    onClose();
  };

  return (
    <Box px={2}>
      <Stack spacing={2} width="450px">
        <Stack direction="row" alignItems="center" spacing={2}>
          <CheckCircleIcon />
          <Typography variant="body2" color="text.secondary">
            Request has been sent to Dashboard creator for approval.
          </Typography>
        </Stack>
        <Typography variant="subtitle2" color="text.secondary">
          You can also send this link to them for 1 click approval
        </Typography>
        <Grid container alignItems="center">
          <Grid item xs>
            <TextField
              defaultValue={dashboardRequestAccessLink}
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs="auto">
            <IconButton onClick={copyMessage}>
              <ContentCopyIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};
